export default __webpack_public_path__ + "img/profile.8150f1b0.jpg";